import React from 'react';

const SharedViewContext = React.createContext({
  isQA: true,
});

SharedViewContext.displayName = 'SharedViewContext';

export default SharedViewContext;
